import API from 'api/helpers/client';
import type { IIndustrySuggestionsParams } from 'api/industries/industries.types.ts';

export const fetchIndustrySuggestions = async (
  payload: IIndustrySuggestionsParams,
): Promise<string[]> => (await API.post('/industries/search', payload)).data;
